import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../utils/app-settings';
import { Observable } from 'rxjs';
import { Album } from '../models/album';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  constructor(private http: HttpClient) { }

  getAlbums(): Observable<Array<Album>> {
    return this.http.get<Array<Album>>(AppSettings.apiUrl + "albums")
  }

}
